<template>
  <div>
    <Dialog title="卡券详情" :hide="editHide" @handleClick="changeClose">
      <div slot="header">卡券详情</div>
      <div slot="body">
        <div class="journalBody">
          <div class="blogCenter ml10">
            <div class="align-item">
              <img
                src="../../assets/images/money/coupon_red_remind.png"
                alt=""
                :style="{ height: '8px' }"
              />
              <p class="pl10 f16">获得时间</p>
            </div>
            <div class="pl20 mt5 f14 color999">
              {{ formatDate(form.getTime) }}
            </div>
          </div>
          <div class="mt20 ml10">
            <div class="align-item">
              <img
                src="../../assets/images/money/coupon_red_remind.png"
                alt=""
                :style="{ height: '8px' }"
              />
              <p class="pl10 f16">活动名称</p>
            </div>
            <div class="pl20 mt5 f14 color999">{{ form.couponPlanName }}</div>
          </div>
          <div class="mt20 ml10">
            <div class="align-item">
              <img
                src="../../assets/images/money/coupon_red_remind.png"
                alt=""
                :style="{ height: '8px' }"
              />
              <p class="pl10 f16">使用规则</p>
            </div>
            <div class="pl20 mt5 f14 color999">{{ form.useRuleStr }}</div>
          </div>
          <div class="mt20 ml10">
            <div class="align-item">
              <img
                src="../../assets/images/money/coupon_red_remind.png"
                alt=""
                :style="{ height: '8px' }"
              />
              <p class="pl10 f16">适用时间</p>
            </div>
            <div class="pl20 mt5 f14 color999">
              <!-- validTimeType dynamic fixed -->
              <!-- {{formatDate(form.beginTime)}} 至 {{formatDate(form.endTime)}} -->
              <template v-if="form.businessPeriodList">
                <div v-for="(item,index) in form.businessPeriodList" :key="index" class="mb10">
                  {{formatDate(item.beginTime)}} - {{formatDate(item.endTime)}}
                </div>
              </template>
              <div v-if="!form.businessPeriodList">永久有效</div>
            </div>
          </div>
          <div class="mt20 ml10">
            <div class="align-item">
              <img
                src="../../assets/images/money/coupon_red_remind.png"
                alt=""
                :style="{ height: '8px' }"
              />
              <p class="pl10 f16">适用范围</p>
            </div>

            <div class="total">
              <div
                v-for="(item, index) in companyListBOList"
                :key="index"
                class="totals-box mt20"
              >
                <div class="flex-row align-items f14">
                  <p class="color111">{{ item.companyName }}</p>
                </div>
                <div class="flex-row align-items f14">
                  <p class="color999">适应门店：{{ item.shopNameStr }}</p>
                </div>
                <div class="flex-row align-items f14">
                  <p class="van-label color999">
                    适应商品：{{ item.productNameStr }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div slot="footer">
          <el-button @click="cancelAciton">取 消</el-button>
          <el-button type="primary" @click="trueAction">确 定</el-button>
        </div> -->
    </Dialog>
  </div>
</template>

<script>
import minxin from "../../assets/javascript/minxin.js";
import Dialog from "../../components/common/dialog.vue";
export default {
  data() {
    return {
      editHide: false,
      form: {},
      id: "",
      companyListBOList: [],
    };
  },
  mixins: [minxin],
  components: { Dialog },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$on("set", function(org) {
        this.editHide = true;
        this.id = org.id;

        this.couponDetail();
      });
    },
    couponDetail() {
      this.$api
        .get(this.$url.member.couponSendRecordDetail, { id: this.id })
        .then((res) => {
          if (res) {
            this.form = res;
            this.companyListBOList = res.companyListBOList;
          }
        });
    },
    changeClose(show) {
      this.editHide = false;
      this.$emit("change", false);
    },
    cancelAciton() {
      this.editHide = false;
    },

    trueAction() {
      this.$emit("change", false);
      this.editHide = false;
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .el-dialog {
  margin-top: 0 !important;
  height: 560px;
  top: calc(50% - 280px);
  border-radius: 10px;
}

/deep/ .el-dialog__body {
  padding: 0 !important;
  .bodys {
    box-sizing: border-box;
    padding: 24px 0;
    height: 475px;
    //   background-color: #F3F4F6;
  }
}

.journalBody {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 0px;
  padding-bottom: 10px;
}

.blogCenter {
  position: relative;
  height: 100%;
  background-color: #fff;
}

.f16 {
  font-size: 16px;
}
.total {
  margin-top: 0px;
  margin-bottom: 20px;
  margin-left: 18px;
  margin-right: 15px;
}
</style>
